import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  apiGetAllOrderId,
  apiGetAllrawMaterial,
  apiPostBom,
  apiGetallBom,
  apiDeleteBom,
  apiUpdateBom,
  apiGetBomDetails,
} from "../../../services/RawMaterialService";

export const getOrderID = createAsyncThunk(
  "order/data/getOrderId",
  async (data) => {
    try {
      const response = await apiGetAllOrderId(data);
      return response.data;
    } catch (error) {
      return error.message;
    }
  }
);

export const getrawMaterial = createAsyncThunk(
  "raw/data/getRawMaterial",
  async (data) => {
    try {
      const response = await apiGetAllrawMaterial(data);
      return response.data;
    } catch (error) {
      return error.message;
    }
  }
);

export const postBom = createAsyncThunk("bom/data/postBom", async (data) => {
  try {
    const response = await apiPostBom(data);
    return response;
  } catch (error) {
    return error.message;
  }
});

export const getBom = createAsyncThunk("bom/data/getBom", async (data) => {
  try {
    const response = await apiGetallBom(data);
    return response.data;
  } catch (error) {
    return error.message;
  }
});

export const deleteBom = createAsyncThunk(
  "bom/data/deleteBom",
  async (data) => {
    try {
      const response = await apiDeleteBom(data);
      return response.data;
    } catch (error) {
      return error.message;
    }
  }
);

export const updateBom = createAsyncThunk(
  "bom/data/updateBom",
  async (data) => {
    try {
      const response = await apiUpdateBom(data);
      return response;
    } catch (error) {
      return error.message;
    }
  }
);

export const getBomDetails = createAsyncThunk(
  "bom/data/getBomDetails",
  async (data) => {
    try {
      const response = await apiGetBomDetails(data);
      return response.data;
    } catch (error) {
      return error.message;
    }
  }
);

export const initialTableData = {
  total: 0,
  pageIndex: 1,
  pageSize: 10,
  query: "",
  sort: {
    order: "",
    key: "",
  },
};

export const initialFilterData = {
  name: "",
  category: ["bags", "cloths", "devices", "shoes", "watches"],
  status: [0, 1, 2],
  productStatus: 0,
};

const dataSlice = createSlice({
  name: "rawList/data",
  initialState: {
    loading: false,
    orderIdList: [],
    rawMaterialList: [],
    bomList: [],
    bomDetailList: {},
    tableData: initialTableData,
    filterData: initialFilterData,
  },
  reducers: {
    updateProductList: (state, action) => {
      state.employeeList = action.payload;
    },
    setTableData: (state, action) => {
      state.tableData = action.payload;
    },
    setFilterData: (state, action) => {
      state.filterData = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBom.pending, (state, action) => {
        state.loading = true;
        state.bomList = [];
      })
      .addCase(getBom.fulfilled, (state, action) => {
        state.loading = false;
        state.bomList = action.payload;
      })
      .addCase(getOrderID.fulfilled, (state, action) => {
        state.orderIdList = action.payload;
      })
      .addCase(getrawMaterial.fulfilled, (state, action) => {
        state.rawMaterialList = action.payload;
      })
      .addCase(updateBom.fulfilled, (state, action) => {})
      .addCase(postBom.fulfilled, (state, action) => {})
      .addCase(deleteBom.fulfilled, (state, action) => {})
      .addCase(getBomDetails.fulfilled, (state, action) => {
        state.bomDetailList = action.payload.data;
      });
  },
});

export const { updateProductList, setTableData, setFilterData } =
  dataSlice.actions;

export default dataSlice.reducer;
